class DocumentationShareChat {

    constructor() {

        this.modalAnimationHeight = 0.97;
        this.modalOpen = false;
        this.folderId = null;
        this.documentId = null;

    }

    initChatShareSection(folderId, documentId) {

        this.folderId = folderId;
        this.documentId = documentId;
        this.modalOpen = true;

        let folderModeView = documentationScreenController.folderModeView;
        let tabs = new Tabs();

        if (baseController.selectedTabId !== tabs.CHAT_TAB) {
            $('#chatSection').remove();
        }

        $('.uploadGroupScrollable').addClass('text-left');
        $('.uploadContentTopArea ').css('bottom', 'unset');

        if (folderModeView === 'advanced' || folderModeView === 'standar') {
            this.openChatShareModalAdvanced();
        }

        if (folderModeView === 'details') {
            this.openChatShareModalDetails();
        }

        let supportRooms = chatScreenController.supportRooms.rooms;
        let otherRooms = chatScreenController.individualRooms.rooms.concat(chatScreenController.groupRooms.rooms, chatScreenController.canalRooms.rooms);
        let roomsToShow = chatScreenController.assistantView ? supportRooms : otherRooms;

        chatScreenController.drawChatList(roomsToShow, false, true);

    }

    openChatShareModalAdvanced() {

        let that = this;
        let modal = $('#uploadGroup-' + this.folderId);
        let modalBody = $('.uploadGroupScrollable');
        let modalBodyFileChooser = $('.tableUploadContainer');
        let modalBackground = $(".uploadModalBackground");
        let modalUploadIconArea = $('.cloudUploadArea');
        let modalUploadBottomSpace = $('.uploadBottomSpace');
        let modalCloseButton = $('.uploadShowButtonArea');
        let modalHeader = $('.uploadContentTopArea');
        let modalHeaderTitle = $('.uploadGroupTitle');
        let modalPosition = $('.uploadGroup.chat-upload-document');
        let currendReadingDocumentId = documentationScreenController.documentationScroll.currentReadingDocument;
        let currendReadingDocument = currendReadingDocumentId ? $('.documentation-advanced-documents-row[data-document="' + currendReadingDocumentId + '"]') : null;

        modalPosition.css('bottom', '0px');

        if (currendReadingDocument) {
            documentationScreenController.documentationScroll.stopCurrentReadingItem(null, currendReadingDocument);
        }

        // Elimina el scroll de la documentacion (para no poder movernos por la docu mientras esta el modal abierto
        $('body').addClass('modalOpen');
        $('body').off("wheel.manageItemScroll touchmove.manageItemScroll");

        window.scrollTo(0,0); // modalBody.last().getNiceScroll()[0].setScrollTop(0);
        modalBodyFileChooser.hide();
        modalUploadIconArea.hide();
        modalUploadBottomSpace.hide();
        modalBackground.show();

        modal.toggleClass('displayedUpload');
        modalHeader.addClass('chat-share-document');
        modalHeaderTitle.text(Translator.trans("TR_COMPARTIR_CON"));
        modal.animate({height: this.modalAnimationHeight * 100 + '%'});

        tintImage('uploadShowButtonCanvas-' + this.folderId , '/images/ico-close.png', world.theme.color_1);
        modalCloseButton.css('border', '2px solid #' + world.theme.color_1);

        $(document).one('click.closeChatShareDocument', '.uploadShowButtonArea', function() {

            modal.animate({height: '0px'}, function() {
                $('.uploadGroupScrollable').find('#chatSection').remove();
                $('.uploadGroupScrollable').removeClass('text-left');
                modalPosition.css('bottom', '-55px');
                modalBackground.hide();
            });

            that.modalOpen = false;
            chatScreenController.sendedProjectDocumentRooms = {};
            chatScreenController.sendProjectDocumentRoomData = {};
            modalHeader.removeClass('chat-share-document');

            $('body').removeClass('modalOpen');
            documentationScreenController.documentationScroll.startScrollManagement(true);

        });

    }

    openChatShareModalDetails() {

        let that = this;
        let modal = $('#uploadGroupDetailsId');
        let modalBody = $('.uploadGroupScrollable');
        let modalHeader = $('.uploadContentTopArea');
        let modalBackground = $('.uploadModalBackground');
        let modalCloseIconArea = $('#uploadShowButtonDetailsId');
        let modalCloseIconCanvas = $('#uploadShowButtonCanvasDetailsId');
        let modalPosition = $('.uploadGroup.chat-upload-document');

        window.scrollTo(0,0); //modalBody.last().getNiceScroll()[0].setScrollTop(0);
        modalPosition.css('bottom', '0px');
        modalBackground.show();
        modalHeader.addClass('chat-share-document');
        modal.animate({height: this.modalAnimationHeight * 100 + '%'});

        tintImage(modalCloseIconCanvas.attr('id'), modalCloseIconCanvas.attr('data-icon'), world.theme.color_1);
        modalCloseIconArea.css('border', '2px solid #' + world.theme.color_1);

        $(document).one('click.closeUploadDocumentModal', '#uploadShowButtonDetailsId', function() {
            modalBackground.hide();
            modal.animate({height: '0px'}, function() {
                $('.uploadGroupScrollable').find('#chatSection').remove();
                $('.uploadGroupScrollable').removeClass('text-left');
                modalPosition.css('bottom', '-55px');
            });
            that.modalOpen = false;
            chatScreenController.sendedProjectDocumentRooms = {};
            chatScreenController.sendProjectDocumentRoomData = {};
            modalHeader.removeClass('chat-share-document');
        });

    }

}